import { Box, FieldSet, Form, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';
import { useMemo } from 'react';

type UpsellSurveyBodyProps = {
  onSurveyResponse: (surveyResponse: { declineReason: string; order: number }) => void;
};

const SURVEY_RESPONSES = [
  { declineReason: 'alreadyEnrolled', label: 'I already have renters insurance' },
  { declineReason: 'enrollLater', label: 'I plan to get it later' },
  { declineReason: 'wontEnrollZillow', label: "I don't want insurance through Zillow" },
  { declineReason: 'other', label: 'Other' },
];

const UpsellSurveyBody = ({ onSurveyResponse }: UpsellSurveyBodyProps) => {
  const shuffledSurveyResponses = useMemo(() => {
    const shuffledResponses = [...SURVEY_RESPONSES];

    for (let i = shuffledResponses.length - 2; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledResponses[i], shuffledResponses[j]] = [shuffledResponses[j], shuffledResponses[i]];
    }

    return shuffledResponses;
  }, []);

  return (
    <Box
      data-testid="upsell-modal-upsell-survey"
      css={{ paddingBottom: 'tighter', paddingTop: { base: 'default', md: 'tighter' } }}
    >
      <Form onSubmit={(e: React.FormEvent) => e.preventDefault()}>
        <FieldSet
          legend={
            <Legend size="lg" css={{ marginBottom: { base: 'loose', md: 'default' } }}>
              Let us know why you don&apos;t want renters insurance
            </Legend>
          }
          optional
        >
          {shuffledSurveyResponses.map((response, index) => (
            <LabeledControl
              key={response.declineReason}
              controlId={response.declineReason}
              label={<Label>{response.label}</Label>}
              control={<Radio name="decline-reason" />}
              onClick={() => onSurveyResponse({ declineReason: response.declineReason, order: index + 1 })}
            />
          ))}
        </FieldSet>
      </Form>
    </Box>
  );
};

export default UpsellSurveyBody;
